import { CRM } from "../constants/modules-id";
import { RestrictionFactory } from "../utils/restriction-factory";

const { WithModuleOr404, ModuleOr404 } = RestrictionFactory(CRM);

export const WithCrmModuleOr404 = WithModuleOr404;
export const CrmModuleOr404 = ModuleOr404;
